import { Component as BaseComponent, h } from 'preact';
import { connect } from 'react-redux';
import { Suspense, lazy } from 'preact/compat';
const InputGroup = lazy(
    () => import(/* webpackChunkName: "input-group" */ '../../shared/form/input-group')
);

class Component extends BaseComponent {
    constructor() {
        super();
        this.state = {
            error: false,
            password: {
                value: null,
                error: null,
            },
            confirm_password: {
                value: null,
                error: null,
            },
        };
    }

    shouldComponentUpdate(nextProps, nextState) {
        if (nextState != this.state) {
            return true;
        }

        if (nextProps.submitting != this.props.submitting) {
            return true;
        }

        if (nextProps.submitted != this.props.submitted) {
            return true;
        }

        if (nextProps.error != this.props.error) {
            return true;
        }

        return false;
    }

    render({ submitting, submitted, reset_key }, { password, confirm_password }) {
        const disabled = !password.value || !confirm_password.value || submitting;
        const img_src = !submitted
            ? 'https://gfx.tarot.com/images/site/animation/hierophant-password.gif'
            : 'https://gfx.tarot.com/images/site/animation/star-password.gif';

        if (!submitted) {
            return (
                <password-reset-set reset_key={reset_key}>
                    <row className='is-wrap'>
                        <column className='is-6 is-push-6-desktop is-push-6-tablet is-12-mobile has-text-center'>
                            <img src={img_src} alt='The Hierophant' />
                        </column>
                        <column className='is-6 is-12-mobile has-text-center-mobile has-padding-10-mobile'>
                            <h6 className='has-text-silver-sand'>YOU'RE ALMOST THERE!</h6>
                            <h1 className='is-hidden-mobile'>Reset your<br />password now</h1>
                            <h4 className='is-visible-mobile'>Reset your password now</h4>
                            <Suspense fallback={<div className='skeleton' />}>
                                <InputGroup
                                    name='password'
                                    type='password'
                                    placeholder='ENTER YOUR NEW PASSWORD'
                                    value={password.value}
                                    error={password.error}
                                    onInput={this.handleChange}
                                />
                            </Suspense>
                            <Suspense fallback={<div className='skeleton' />}>
                                <InputGroup
                                    name='confirm_password'
                                    type='password'
                                    placeholder='CONFIRM YOUR NEW PASSWORD'
                                    value={confirm_password.value}
                                    error={confirm_password.error}
                                    onInput={this.handleChange}
                                />
                            </Suspense>
                            {this.renderError()}
                            <button
                                className={`button ${disabled ? 'disabled' : ''}`}
                                disabled={disabled}
                                onClick={this.submit}
                            >
                                {submitting ? 'SUBMITTING…' : 'SAVE NEW PASSWORD'}
                            </button>
                            {this.renderCheckoutLink()}
                        </column>
                    </row>
                </password-reset-set>
            );
        }

        return (
            <password-reset-set>
                <row className='is-wrap'>
                    <column className='is-6 is-push-6-desktop is-push-6-tablet is-12-mobile has-text-center'>
                        <img src={img_src} alt='The Star' />
                    </column>
                    <column className='is-6 is-12-mobile has-text-center-mobile has-padding-10-mobile'>
                        <h6 className='has-text-silver-sand'>YOU'VE REACHED THE FINISH LINE!</h6>
                        <h1 className='is-hidden-mobile'>Success!<br />Your password<br />has been updated!</h1>
                        <h4 className='is-visible-mobile'>Success!<br />Your password has been updated!</h4>
                        <hr />
                        <h6 className='has-text-silver-sand'>NOW THAT THAT'S ALL SQUARED AWAY…</h6>
                        <p>
                            <a href='/daily-horoscope'>Read your horoscope for today</a><br />
                            <a href='/daily-love-horoscope'>Get love advice for today</a><br />
                            <a href='/astrology/weekly-love-horoscopes'>Read your Weekly Love Horoscope</a>
                        </p>
                        {this.renderCheckoutLink()}
                    </column>
                </row>
            </password-reset-set>
        );
    }

    renderError = () => {
        if (this.props.error) {
            return (
                <p className='is-error' dangerouslySetInnerHTML={{ __html: this.props.error }} />
            );
        }

        return null;
    }

    renderCheckoutLink = () => {
        if (this.props.order_uuid) {
            /* eslint-disable react/jsx-no-target-blank */
            return (
                <p>
                    <a
                        href={`/checkout?order=${this.props.order_uuid}`}
                        target='_blank'
                        className='is-block has-margin-20-top'
                    >
                        Back to what I was doing
                    </a>
                </p>
            );
            /* eslint-enable react/jsx-no-target-blank */
        }

        return null;
    }

    handleChange = (e) => {
        let state = this.state;

        state[e.target.name].value = e.target.value;

        this.setState(state);
    }

    submit = () => {
        let state = this.state;
        state.error = false;

        if (!state.password.value) {
            state.password.error = 'Password is required';
            state.error = true;
        }

        if (!state.confirm_password.value) {
            state.confirm_password.error = 'Password confirmation is required';
            state.error = true;
        }

        if (state.password.value != state.confirm_password.value) {
            state.password.error = 'Passwords do not match';
            state.confirm_password.error = 'Passwords do not match';
            state.error = true;
        }

        if (state.error) {
            this.setState(state);
        } else {
            this.props.passwordResetSet({
                password: state.password.value,
                confirm_password: state.confirm_password.value,
                key: this.props.reset_key,
            });
        }

        return false;
    }
}

const mapStateToProps = (state) => ({
    submitting: state.form && state.form.submitting,
    submitted: state.form && state.form.submitted,
    error: state.form && state.form.error,
    order_uuid: state.checkout && state.checkout.order_uuid,
});

const mapDispatchToProps = (dispatch) => ({
    passwordResetSet: (payload) => dispatch({ type: 'member:password-reset-set', payload: payload }),
});

export default connect(mapStateToProps, mapDispatchToProps)(Component);
